<template>
  <div>
    <!-- browser back & user name -->
    <div v-if="isMobile && isFollowPage" class="flex items-center h-13 border-b mb-4">
      <OButton pure class="w-11 h-11 u-center hover:bg-gray-100" :aria-label="$t('profile.back')" :href="userProfileUrl">
        <OIcon icon="arrow-right-blue" svg-class="h-5 rotate-180" />
      </OButton>
      <div v-if="state.user" class="font-bold text-lg text-o-blue ml-2.5 my-3">{{ state.user.name || state.user.username }}</div>
    </div>

    <!--mobile follow tabs-->
    <div v-if="isFollowPage" class="tabs u-center justify-start w-full px-6 text-lg font-semibold border-b border-divider-100">
      <nuxt-link :to="`/${PROFILE_PATH}/${username}/${FOLLOWINGS_PATH}`" rel="nofollow" class="u-center px-4 sm:px-6 h-15">
        {{ $t('profile.follows') }}
      </nuxt-link>
      <nuxt-link :to="`/${PROFILE_PATH}/${username}/${FOLLOWERS_PATH}`" rel="nofollow" class="u-center px-4 sm:px-6 h-15">
        {{ $t('profile.followers') }}
      </nuxt-link>
    </div>

    <!-- profile tabs desktop&mobile-->
    <div>
      <div
        v-if="!isFollowPage"
        class="tabs flex justify-start text-lg font-semibold px-6 border-b border-divider-100 w-full overflow-x-auto"
      >
        <nuxt-link v-if="hasContent" :to="`/${PROFILE_PATH}/${username}`" class="u-center px-4 sm:px-6 h-15">
          {{ $t('profile.contents') }}
        </nuxt-link>
        <nuxt-link
          :to="hasContent ? `/${PROFILE_PATH}/${username}/${FAVORITE_PATH}` : `/${PROFILE_PATH}/${username}`"
          rel="nofollow"
          class="u-center px-4 sm:px-6 h-15"
        >
          {{ $t('user-popover.reading-list') }}
        </nuxt-link>
        <nuxt-link :to="`/${PROFILE_PATH}/${username}/${COMMENTS_PATH}`" class="u-center px-4 sm:px-6 h-15">
          {{ $t('profile.comments') }}
        </nuxt-link>
      </div>
      <div class="tab-content px-6">
        <Icerikler v-if="isDefaultTab && hasContent" :id="id" />
        <Favoriler v-else-if="isDefaultTab && !hasContent" :id="id" />
        <nuxt-child v-else :id="id" :key="id" />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, useRoute } from '@nuxtjs/composition-api';
import { useDevice } from '@/composables/useDevice';
import { useProfile } from '@/modules/profile/state/useProfile';
import { getProfileUrl } from '~/modules/common/utils/routingUtils';
import { OButton, OIcon } from '~/modules/common/components/ui';
import { FOLLOWERS_PATH, FOLLOWINGS_PATH, COMMENTS_PATH, PROFILE_PATH, FAVORITE_PATH } from '~/constants/config';
import { useAuth } from '~/modules/auth/state/useAuth';
import Favoriler from '~/pages/profil/_username/index/favoriler.vue';
import Icerikler from '~/pages/profil/_username/index/icerikler.vue';
export default defineComponent({
  components: { Favoriler, Icerikler, OButton, OIcon },
  setup() {
    const { isMobile } = useDevice();
    const { user } = useAuth();
    const route = useRoute();
    const { state } = useProfile();

    const username = route.value.params.username;
    const id = computed(() => state.value.user?._id);
    const userProfileUrl = computed(() => getProfileUrl({ user: state.value.user }));
    const isMe = user.value?.username === username;
    const isFollowPage = computed(() => route.value.path.includes(FOLLOWERS_PATH) || route.value.path.includes(FOLLOWINGS_PATH));
    const isDefaultTab = computed(() => route.value.path === userProfileUrl.value);
    const hasContent = state.value.user?.stats?.articles > 0;

    return {
      isMobile,
      state,
      username,
      id,
      isMe,
      hasContent,
      isFollowPage,
      isDefaultTab,
      FOLLOWERS_PATH,
      FOLLOWINGS_PATH,
      COMMENTS_PATH,
      PROFILE_PATH,
      FAVORITE_PATH,
      userProfileUrl,
    };
  },
});
</script>
<style lang="scss" scoped>
.tabs {
  font-weight: 600;
  > .nuxt-link-exact-active {
    border-top: 1px solid var(--border-divider-100);
    border-right: 1px solid var(--border-divider-100);
    border-left: 1px solid var(--border-divider-100);
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    color: var(--text-anchor);
    position: relative;
    &:before {
      background-color: var(--text-anchor);
      content: '';
      width: 53px;
      height: 5px;
      position: absolute;
      bottom: 0;
      border-top-right-radius: 124px;
      border-top-left-radius: 124px;
    }
  }
}
</style>
